import styled from "@emotion/styled";
import { MDSButton, MDSButtonVariant } from "@/mds";

interface YesNoInputProps {
  name: string;
  value: boolean;
  onChange: (createFromHashtags: boolean) => void;
}

export const YesNoInput = ({ name, value, onChange }: YesNoInputProps) => (
  <>
    <input
      type="hidden"
      name={name}
      value={value ? "yes" : "no"}
      onChange={() => onChange(!value)}
    />
    <StyledWrapper>
      <MDSButton
        variant={MDSButtonVariant.Toggle}
        aria-label="No"
        onClick={() => onChange(false)}
        isToggled={!value}
      >
        No
      </MDSButton>
      <MDSButton
        variant={MDSButtonVariant.Toggle}
        aria-label="Yes"
        onClick={() => onChange(true)}
        isToggled={value}
      >
        Yes
      </MDSButton>
    </StyledWrapper>
  </>
);

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing[2]};
  width: 100%;

  > * {
    flex: 1;
  }
`;
